import { useRemovePhoneNumberModalStore } from "@forwardflow/store/modal";
import { Modal } from "antd";

export const RemovePhoneNumberModal = () => {
   const { isRemovePhoneNumberModalOpen, closeRemovePhoneNumberModal } =
      useRemovePhoneNumberModalStore();
   return (
      <>
         <Modal
            className="ff-modal"
            title="Remove numbers Permanently"
            open={isRemovePhoneNumberModalOpen}
            onCancel={closeRemovePhoneNumberModal}
            footer={null}
         >
            <p className="mt-5 mb-14">
               Removing this numbers will result in having less phone numbers to
               work with for the Facebook Sellers Campaign
            </p>
            <button className="w-full h-12 font-semibold transition-all border rounded bg-danger/20 hover:bg-danger/50 border-danger">
               Remove number
            </button>
            <button
               onClick={closeRemovePhoneNumberModal}
               className="w-full h-12 mt-2 font-semibold transition-all border rounded border-white/20 hover:bg-white/10"
            >
               Cancel
            </button>
         </Modal>
      </>
   );
};
